import { OvTableData } from '../../../components/UI/molecules/OvTable';
import i18n from '../../../i18n/config';
import { HormonePatternContent } from '../../model/dto/hormone-pattern-content';
import { TableRowEditWidgetType } from '../../model/ui/table-row-edit-widget.type';

export class HormonePatternContentDataUtils {
  static mapHormonePatternContentToTableData(
    hormonePatternContent?: HormonePatternContent
  ): OvTableData {
    return [
      {
        label: 'hormonePatternContents.fields.key',
        value: hormonePatternContent?.key,
        translateLabel: true,
      },
      {
        label: 'hormonePatternContents.fields.name',
        value: hormonePatternContent?.name,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'name',
          placeholder: i18n.t('hormonePatternContents.fields.name'),
        },
      },
      {
        label: 'hormonePatternContents.fields.shortDescription',
        value: hormonePatternContent?.short_description,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT,
          propertyName: 'short_description',
          placeholder: i18n.t('hormonePatternContents.fields.shortDescription'),
        },
      },
      {
        label: 'hormonePatternContents.fields.meaning',
        value: hormonePatternContent?.meaning,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.FORMATTED_TEXT_AREA,
          propertyName: 'meaning',
          placeholder: i18n.t('hormonePatternContents.fields.meaning'),
        },
      },
      {
        label: 'hormonePatternContents.fields.commonSymptoms',
        value: hormonePatternContent?.common_symptoms,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_ARRAY,
          propertyName: 'common_symptoms',
          placeholder: i18n.t('hormonePatternContents.fields.commonSymptoms'),
        },
      },
      {
        label: 'hormonePatternContents.fields.lifeStyleImprovements',
        value: hormonePatternContent?.lifestyle_improvement_options,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_ARRAY,
          propertyName: 'lifestyle_improvement_options',
          placeholder: i18n.t(
            'hormonePatternContents.fields.lifeStyleImprovements'
          ),
        },
      },
      {
        label: 'hormonePatternContents.fields.questionsToAskYourDoctor',
        value: hormonePatternContent?.questions_to_ask_your_doctor,
        translateLabel: true,
        editOptions: {
          widgetType: TableRowEditWidgetType.TEXT_ARRAY,
          propertyName: 'questions_to_ask_your_doctor',
          placeholder: i18n.t(
            'hormonePatternContents.fields.questionsToAskYourDoctor'
          ),
        },
      },
      {
        label: 'hormonePatternContents.fields.numberOfTimesDetected',
        value: hormonePatternContent?.number_of_times_detected,
        translateLabel: true,
      },
    ];
  }
}
